import React from 'react';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { CenterDataForm, CenterFilters } from '../../../../app/models/Center';
import useCenterService from '../../../../app/services/hooks/useCenterService';

interface Props {
  centers: CenterDataForm[];
  totalRows: number;
  loading?: boolean;
  edit?: (id: number) => void;
  show?: (id: number) => void;
  destroy?: (id: number) => void;
  filter: CenterFilters;
  setFilter: (filter: CenterFilters) => void;
  callbackSuccess: () => void;
}

const CenterSwitchChange: React.FC<{
  checkValue?: boolean;
  centerId: number;
  callbackSuccess: () => void;
}> = ({ checkValue, centerId, callbackSuccess }) => {
  const { activeCenter } = useCenterService();
  return (
    <div className="form-check form-switch">
      <input
        type="checkbox"
        className="form-check-input"
        checked={!!checkValue}
        onChange={(e) => {
          activeCenter(centerId, e.target.checked, {
            onSuccess: () => callbackSuccess(),
            onError: () => callbackSuccess()
          });
        }}
      />
    </div>
  );
};

// src/pages/Centers/components/tables/CenterDataTable.tsx
const CenterDataTable = ({
  centers, totalRows, loading = false, edit, show, destroy, filter, setFilter, callbackSuccess
}: Props) => {
  const columns = [
    { name: 'Id', selector: (row: any) => row.id, sortable: true, sortField: 'id',
      cell: (row: CenterDataForm) => <span>{row.id}</span> },

    { name: 'Sociedad', selector: (row:any) => row.society_business_name, sortable: true, sortField: 'society__business_name',
      cell: (row:CenterDataForm) => <span>{row.society_business_name ?? ''}</span> },

    { name: 'Nombre', selector: (row: any) => row.name, sortable: true, sortField: 'name',
      cell: (row: CenterDataForm) => <span>{row.name}</span> },
    { name: 'Dirección', selector: (row: any) => row.address, sortable: true, sortField: 'address',
      cell: (row: CenterDataForm) => <span>{row.address}</span> },

    { name: 'Estado', selector: (row: any) => row?.is_active, sortable: true, sortField: 'is_active', width: '100px',
      cell: (row: CenterDataForm) => (
        <CenterSwitchChange
          checkValue={row.is_active ?? true}
          centerId={row.id ?? -1}
          callbackSuccess={callbackSuccess}
        />
      ) },

    {
      name: 'Acciones',
      selector: (row: any) => row.id,
      sortable: false,
      cell: (row: CenterDataForm) => (
        <div>
          {show && (
            <ButtonTableAction
              callbackFunction={() => show(row.id ?? -1)}
              classIcon="mdi mdi-eye"          // ⬅️ antes: className
              colorIcon="text-info"
              title="Ver"
            />
          )}
          {edit && (
            <ButtonTableAction
              callbackFunction={() => edit(row.id ?? -1)}
              classIcon="mdi mdi-pencil"       // ⬅️ antes: className
              colorIcon="text-warning"
              title="Editar"
            />
          )}
          {destroy && (
            <ButtonTableAction
              callbackFunction={() => destroy(row.id ?? -1)}
              classIcon="mdi mdi-delete"       // ⬅️ antes: className
              colorIcon="text-danger"
              title="Eliminar"
            />
          )}
        </div>
      )
    }
  ];

  return (
    <>
      <div className="row mt-3"><div className="col">{/* Filtros visuales ya están en la página */}</div></div>
      <DefaultDataTable
        columns={columns}
        data={centers}
        progressPending={loading}
        paginationTotalRows={totalRows}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};


export default CenterDataTable;
